import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from 'vue-router/composables';
import { Hiring, hiringPaidCustody } from '../../services/paid-custody';
import { ObjectiveBuilderComponents, EPaidCustodySteps } from './helpers';
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaidCustody',
  setup(__props) {

const route = useRoute();
const hiring = ref<Hiring | null>(null);
const hasError = ref(false);
const loadingPassword = ref(false);

const currentStep = ref(
  route.params.status ? EPaidCustodySteps.CANCEL : EPaidCustodySteps.ACTIVE
);

const goToNextStep = async () => {
  const isSuccess = await fetchHiring();

  if (isSuccess) {
    currentStep.value = EPaidCustodySteps.COMPLETED;
  }
};

const fetchHiring = async () => {
  try {
    loadingPassword.value = true;
    hasError.value = false;

    const response = await hiringPaidCustody();

    hiring.value = response;

    return true;
  } catch (e) {
    hasError.value = true;

    return false;
  } finally {
    loadingPassword.value = false;
  }
};

const stepComponent = computed(
  () => ObjectiveBuilderComponents[currentStep.value]
);

return { __sfc: true,route, hiring, hasError, loadingPassword, currentStep, goToNextStep, fetchHiring, stepComponent }
}

})